<template>
  <v-btn
    v-scroll="onScroll"
    v-show="fab"
    fixed
    bottom
    right
    color="#E8320D"
    @click="toBottom"
    class="btn-go-down"
  >
    <span
      v-html="$t('component.btn-go-to-preview-schedule', { split: '<br>' })"
    ></span>
    <v-icon>{{ iconArrow }}</v-icon>
  </v-btn>
</template>

<script>
import { mdiArrowDown } from '@mdi/js';

export default {
  name: 'scrollTopBtn',
  data() {
    return {
      iconArrow: mdiArrowDown,
      fab: false
    };
  },
  methods: {
    onScroll(e) {
      if (typeof window === 'undefined') return;
      const top = window.pageYOffset || e.target.scrollTop || 0;

      const heightDocument =
        document.getElementById('interview-scroll').offsetTop;
      this.heightDocument = heightDocument * 0.95;
      this.fab = top >= 0 && top < heightDocument / 1.2;
    },

    toBottom() {
      this.$vuetify.goTo(this.heightDocument, {
        container: document.documentElement
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../style/devices.scss';
.btn-go-down {
  height: 55px !important;
  color: white !important;
  text-transform: initial;
  display: none;
}

@include mobile {
  .btn-go-down {
    display: block;
  }
}
</style>
